import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NoteAddOutlined } from '@mui/icons-material';
import { CircularProgress, IconButton, Box } from '@mui/material';
import { FadingTooltip } from '@cosmotech/ui';
import { ACL_PERMISSIONS } from '../../../../../../services/config/accessControl';
import {
  useDatastoreTables,
  useResetValidationState,
  useValidationState,
  useAssociatedRunners,
  useSelectedDataset,
  useStartDatastoreRunner,
} from '../../../../../../state/hooks/DatastoreHooks';

export const PushDataStoreButton = () => {
  const { t } = useTranslation();
  const validationState = useValidationState();
  const resetValidationState = useResetValidationState();
  const startRunner = useStartDatastoreRunner();
  const associatedRunners = useAssociatedRunners();
  const datastoreTables = useDatastoreTables();
  const dataset = useSelectedDataset();

  const hasNoTables = datastoreTables.length === 0;
  const isPushRunning = associatedRunners?.push?.state === 'Running';
  const isValidationRunning = associatedRunners?.validation?.state === 'Running';
  const disabled = hasNoTables || validationState?.status !== 'valid' || isPushRunning || isValidationRunning;

  const userPermissionsOnDataset = dataset?.security?.currentUserPermissions ?? [];
  const canUserPublish = userPermissionsOnDataset.includes(ACL_PERMISSIONS.DATASET.WRITE);

  const startValidation = useCallback(() => {
    startRunner('push');
    resetValidationState();
  }, [resetValidationState, startRunner]);

  return canUserPublish ? (
    <Box sx={{ position: 'relative' }}>
      {isPushRunning ? (
        <span style={{ padding: '8px' }}>
          <CircularProgress
            sx={{
              color: 'white',
              height: '24px !important',
              width: '24px !important',
              top: '2px',
              position: 'relative',
            }}
          />
        </span>
      ) : (
        <>
          <FadingTooltip title={t('commoncomponents.datastore.push.tooltip', 'Create a Dataset from the datastore')}>
            <IconButton color="primary" onClick={() => startValidation()} disabled={disabled}>
              <NoteAddOutlined fontSize="large" />
            </IconButton>
          </FadingTooltip>
        </>
      )}
    </Box>
  ) : null;
};
